// Stock for product with presentations uses stock of every presentation
export const isProductWithoutStock = ({
  stockQty,
  presentationItems,
}: {
  stockQty: number | null;
  presentationItems?: { stockQty: number | null }[];
}): boolean => {
  return Array.isArray(presentationItems)
    ? presentationItems.every(item => item.stockQty === 0) || false
    : stockQty === 0;
};
